import { useMemo as S, useState as M, useCallback as E, useEffect as W } from "react";
import { g as C } from "./_commonjsHelpers.js";
import { _ as N, a as A } from "./_baseGetTag.js";
import "../theme/index.js";
import { useTheme as H } from "../theme/hooks/index.js";
function R(e) {
  var n = typeof e;
  return e != null && (n == "object" || n == "function");
}
var $ = R, B = N, D = function() {
  return B.Date.now();
}, F = D, G = /\s/;
function P(e) {
  for (var n = e.length; n-- && G.test(e.charAt(n)); )
    ;
  return n;
}
var U = P, X = U, q = /^\s+/;
function J(e) {
  return e && e.slice(0, X(e) + 1).replace(q, "");
}
var K = J;
function Q(e) {
  return e != null && typeof e == "object";
}
var V = Q, Y = A, Z = V, ee = "[object Symbol]";
function ne(e) {
  return typeof e == "symbol" || Z(e) && Y(e) == ee;
}
var te = ne, ie = K, j = $, re = te, O = NaN, se = /^[-+]0x[0-9a-f]+$/i, oe = /^0b[01]+$/i, ae = /^0o[0-7]+$/i, ce = parseInt;
function de(e) {
  if (typeof e == "number")
    return e;
  if (re(e))
    return O;
  if (j(e)) {
    var n = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = j(n) ? n + "" : n;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = ie(e);
  var t = oe.test(e);
  return t || ae.test(e) ? ce(e.slice(2), t ? 2 : 8) : se.test(e) ? O : +e;
}
var fe = de, ue = $, T = F, _ = fe, me = "Expected a function", be = Math.max, le = Math.min;
function he(e, n, t) {
  var r, l, f, a, s, c, u = 0, o = !1, d = !1, m = !0;
  if (typeof e != "function")
    throw new TypeError(me);
  n = _(n) || 0, ue(t) && (o = !!t.leading, d = "maxWait" in t, f = d ? be(_(t.maxWait) || 0, n) : f, m = "trailing" in t ? !!t.trailing : m);
  function h(i) {
    var b = r, g = l;
    return r = l = void 0, u = i, a = e.apply(g, b), a;
  }
  function p(i) {
    return u = i, s = setTimeout(v, n), o ? h(i) : a;
  }
  function k(i) {
    var b = i - c, g = i - u, w = n - b;
    return d ? le(w, f - g) : w;
  }
  function x(i) {
    var b = i - c, g = i - u;
    return c === void 0 || b >= n || b < 0 || d && g >= f;
  }
  function v() {
    var i = T();
    if (x(i))
      return I(i);
    s = setTimeout(v, k(i));
  }
  function I(i) {
    return s = void 0, m && r ? h(i) : (r = l = void 0, a);
  }
  function L() {
    s !== void 0 && clearTimeout(s), u = 0, r = c = l = s = void 0;
  }
  function z() {
    return s === void 0 ? a : I(T());
  }
  function y() {
    var i = T(), b = x(i);
    if (r = arguments, l = this, c = i, b) {
      if (s === void 0)
        return p(c);
      if (d)
        return clearTimeout(s), s = setTimeout(v, n), h(c);
    }
    return s === void 0 && (s = setTimeout(v, n)), a;
  }
  return y.cancel = L, y.flush = z, y;
}
var ge = he;
const ve = /* @__PURE__ */ C(ge), pe = (e) => Object.entries(e).map(
  ([n, t]) => [n, parseInt(t, 10)]
).sort((n, t) => n[1] - t[1]);
function Se() {
  var u;
  const n = H().screens, t = S(
    () => pe(n),
    [n]
  ), [r, l] = M({
    width: window.innerWidth,
    height: window.innerHeight
  });
  let f = (u = t.find(([, o], d) => {
    var m;
    return r.width >= o && r.width < (((m = t[d + 1]) == null ? void 0 : m[1]) ?? 1 / 0);
  })) == null ? void 0 : u[0];
  const a = S(
    () => Object.fromEntries(t),
    [t]
  );
  f === void 0 && (f = t[t.length - 1][0]);
  const s = E(
    (o) => {
      var h;
      const d = t.findIndex((p) => p[0] === o), m = ((h = t[d + 1]) == null ? void 0 : h[1]) || 1 / 0;
      return r.width <= m;
    },
    [r, t]
  ), c = E(
    (o) => r.width >= (a[o] || 0),
    [r, a]
  );
  return W(() => {
    const o = ve(() => {
      l({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }, 250);
    return window.addEventListener("resize", o), () => {
      window.removeEventListener("resize", o), o.cancel();
    };
  }, []), {
    ...r,
    size: f,
    mediaMax: s,
    mediaMin: c
  };
}
export {
  pe as g,
  Se as u
};
